// extracted by mini-css-extract-plugin
export default {"article":"ArticleRenderer_article__P1Bkv"};